import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "SpinnerIcon_svg__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M-.999 32.999v-34h34v17h-17v17Z",
          "data-name": "Union 352"
        })
      ])
    ], -1),
    _createElementVNode("g", {
      "clip-path": "url(#SpinnerIcon_svg__a)",
      "data-name": "Mask Group 57",
      transform: "translate(.999 1.001)"
    }, [
      _createElementVNode("path", {
        fill: "none",
        stroke: "#4493fc",
        "stroke-width": "4",
        d: "M16 1.714A14.286 14.286 0 1 1 1.714 16 14.286 14.286 0 0 1 16 1.714Z",
        "data-name": "Path 16627"
      })
    ], -1)
  ]))]))
}
export default { render: render }